/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { TenantCouponWithCode } from './TenantCouponWithCode';
import { TenantCouponWithoutCode } from './TenantCouponWithoutCode';
const TenantCouponParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['coupon-with-code', TenantCouponWithCode],
    ['coupon-without-code', TenantCouponWithoutCode],
]);
export const TenantCoupon = TenantCouponParser;
